import { useMemo } from "react";
import { useAppState } from "../../providers/app-state";
import useProducts from "../../services/product";
import { useTransition, animated, config } from "@react-spring/web";
import { upsale_step_heading, upsale_step_secondary_heading } from "../../lang/da";

const UpsaleScreen = () => {
    const { state, dispatch } = useAppState();
    const { data, isLoading } = useProducts();


    //Find the upsale product ids in selected repairs, and finds the relevant products the in the product list.
    const upsaleProducts = useMemo(() => {
        if (!data) return;

        const flattenedProducts = data.reduce((acc, cur) => {
            return [...acc, ...cur.childs.map(child => child.products).flat()]
        }, [])

        const upsales = state.selectedRepairs
            .filter(rep => rep.categoryUpsaleProducts || rep.secondLevelCategoryUpsaleProducts)
            .map(rep => [...(rep.categoryUpsaleProducts ?? []), ...(rep.secondLevelCategoryUpsaleProducts ?? [])])
            .flat()
            .filter((item, index, arr) => arr.indexOf(item) === index)

        return flattenedProducts.filter(p => upsales.includes(String(p.id)))

    }, [data, state.selectedRepairs])

    const transition = useTransition(upsaleProducts || [], {
        config: config.stiff,
        trail: 700 / upsaleProducts?.length,
        delay: 300,
        from: {
            opacity: 0,
            scale: 0.5,
        },
        enter: {
            opacity: 1,
            scale: 1,
        }
    })

    if (isLoading) return <p>Loading</p>

    return (
        <animated.div
            className="py-12 md:py-20"
        >
            <p
                className="text-2xl md:text-4xl mb-3"
            >
                {
                    upsale_step_heading
                }
            </p>
            <p
                className="mb-5 font-light text-sm md:text-md"
            >
                {
                    upsale_step_secondary_heading
                }
            </p>
            <div
                className="flex flex-wrap -mx-3"
            >
                {
                    transition((style, p) => {
                        return (
                            <animated.div
                                className="bg-skgBlue p-5 text-white rounded-md flex-grow basis-1/3 m-3 shadow-md relative overflow-hidden"
                                style={{
                                    minWidth: 320,
                                    ...style
                                }}
                            >
                                <div
                                    className="absolute z-10 top-5 -right-9  text-[rgba(255,255,255,.3)]"
                                >
                                    <div
                                        className={`icon ${p.icon} text-9xl`}
                                        style={{
                                            fontWeight: "bolder"
                                        }}
                                    />
                                </div>
                                <div
                                    className="space-y-4 z-20 relative flex flex-col justify-between h-full"
                                >
                                    <p
                                        className="text-2xl font-light"
                                    >
                                        {p.name}
                                    </p>
                                    <div
                                        className="font-light text-sm"
                                        dangerouslySetInnerHTML={{ __html: p.description }}
                                    />
                                    <div>
                                        <p
                                            className="text-skgRed"
                                        >
                                            {
                                                Math.round(p.upsale_pct) + "% Rabat"
                                            }
                                        </p>
                                        <p
                                            className="line-through"
                                        >
                                            {
                                                p.price
                                            }
                                        </p>
                                        {
                                            p.price && (
                                                <p>
                                                    Til {Math.round((p.price.match(/\d+/)) * (100 - Number(p.upsale_pct)) / 100)},-
                                                </p>
                                            )
                                        }
                                        <div
                                            className="w-full p-4 rounded-md bg-[rgba(255,255,255,.3)] hover:bg-[rgba(255,255,255,.8)] mt-4 cursor-pointer"
                                            onClick={() => {
                                                state.selectedUpsales.some(sp => sp.id === p.id)
                                                    ? dispatch({
                                                        key: "selectedUpsales",
                                                        value: [...state.selectedUpsales.filter(sp => sp.id !== p.id)]
                                                    })
                                                    : dispatch({
                                                        key: "selectedUpsales",
                                                        value: [...state.selectedUpsales, p]
                                                    })
                                            }}
                                        >
                                            {
                                                state.selectedUpsales.some(sp => sp.id === p.id)
                                                    ? "Fjern fra kurv"
                                                    : "Tilføj til kurv"
                                            }
                                        </div>
                                    </div>
                                </div>
                            </animated.div>
                        )
                    })
                }
                {
                    (upsaleProducts.length % 2)
                        ? (
                            <div
                                className="flex-grow basis-1/3 m-3"
                                style={{
                                    minWidth: 320,
                                }}
                            />
                        )
                        : null
                }
            </div>
        </animated.div>
    )
}

export default UpsaleScreen;